export default {"src":"/_next/static/media/error-icon.f2e4311a.svg","height":59,"width":60,"blurWidth":0,"blurHeight":0};